export const i18n = require('core/localization/localization').translator({
	"Add Rule": {
		"no": "Legg til regel"
	},
	'Add Group': {
		no: 'Legg til gruppe'
	}
});
